export const maid = {
  maidQuoteSelectedPlan: (state) => {
    if (state.quotation.maidForm.planNo && state.quotation.maidParam.plans.plans && state.quotation.maidParam.plans.plans.length > 0) {
      const selectedPlan = state.quotation.maidParam.plans.plans.find(x => x.planNo === state.quotation.maidForm.planNo)
      if (selectedPlan) {
        return selectedPlan
      }
    }
    return null
  }
}
